import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, memo } from 'react';
import { styled, useDeprecatedCheck, useThemeProps, } from '../../foundation';
import { RcIcon } from '../Icon';
import { StyledThumbnail } from './styles';
var _RcThumbnail = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcThumbnail' });
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useDeprecatedCheck(RcThumbnail, props, [
            {
                prop: 'iconType',
                time: '2021-2',
                comment: 'Please use symbol to set icon',
            },
            {
                prop: 'url',
                time: '2021-2',
                comment: 'Please use src to set url',
            },
        ]);
    }
    var url = props.url, _a = props.src, src = _a === void 0 ? url : _a, iconType = props.iconType, size = props.size, symbol = props.symbol, rest = __rest(props, ["url", "src", "iconType", "size", "symbol"]);
    return (React.createElement(React.Fragment, null, src ? (React.createElement(StyledThumbnail, __assign({ ref: ref, src: src, size: size, "data-test-automation-id": "thumbnail" }, rest))) : (React.createElement(RcIcon, __assign({ ref: ref, "data-test-automation-id": "iconThumbnail" }, rest, { size: size === 'small' ? 'small' : 'xxxlarge', symbol: symbol }), iconType))));
});
var RcThumbnail = styled(memo(_RcThumbnail))(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcThumbnail.defaultProps = {
    size: 'large',
};
RcThumbnail.displayName = 'RcThumbnail';
export { RcThumbnail };
var templateObject_1;
